import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import cyc from '@rumblefish/ui/src/assets/svg/RumbleFish23Theme/clients/cyc.svg';
import makerDao from '@rumblefish/ui/src/assets/svg/RumbleFish23Theme/clients/dao.svg';
import solar from '@rumblefish/ui/src/assets/svg/RumbleFish23Theme/clients/solar.svg';
import space from '@rumblefish/ui/src/assets/svg/RumbleFish23Theme/clients/space.svg';
import verify from '@rumblefish/ui/src/assets/svg/RumbleFish23Theme/clients/verify.svg';
import zbay from '@rumblefish/ui/src/assets/svg/RumbleFish23Theme/clients/zbay.svg';
import type { OurClientsProps } from './OurClients.types';
import {
  StyledHeadline,
  StyledImage,
  StyledLogoWrapper,
  StyledStack,
  StyledWrapper,
} from './styles';

export const OurClients = ({ ...props }: OurClientsProps) => (
  <Section width="small">
    <StyledWrapper {...props} spacing={4}>
      <StyledStack>
        <StyledHeadline variant="display_sm">
          We're trusted by global innovators and leaders. Join them!
        </StyledHeadline>

        <StyledLogoWrapper>
          <StyledImage src={cyc} alt="Connect Your Care" />
          <StyledImage src={makerDao} alt="Maker DAO" />
          <StyledImage src={solar} alt="Solar Generation" />
          <StyledImage src={space} alt="Space Inch" />
          <StyledImage src={verify} alt="Verify ID" />
          <StyledImage src={zbay} alt="Zbay" />
        </StyledLogoWrapper>
      </StyledStack>
    </StyledWrapper>
  </Section>
);
